import { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config';
import fetchWithAuth from '../utils/fetchWithAuth';

const useAssignments = () => {
  const [assignments, setAssignments] = useState([]);
  const [refreshAssignments, setRefreshAssignments] = useState(false);
  const [genericSavedMsg, setgenericSavedMsg] = useState("");

  useEffect(() => {
    fetchWithAuth(`${BACKEND_URL}/assignments`)
      .then(res => res.json())
      .then(data => setAssignments(data));
  }, [refreshAssignments]);

  const addAssignment = async (assignmentData) => {
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/assignments`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(assignmentData)
      });
      const result = await response.json();
      if (!response.ok) {
        setgenericSavedMsg(result.error || "Error al guardar la asignación");
        return { error: result.error };
      }
      setgenericSavedMsg("Asignación guardada exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
      setRefreshAssignments(r => !r);
      return {};
    } catch (err) {
      setgenericSavedMsg("Error al guardar la asignación");
      return { error: "Error al guardar la asignación" };
    }
  };

  // Optionally, add edit/delete logic here if needed

  return {
    assignments,
    addAssignment,
    refreshAssignments,
    setRefreshAssignments,
    genericSavedMsg
  };
};

export default useAssignments;